module.exports = __webpack_public_path__ + "img/paper-airplane.635e6536.png";